const mutations = {
  confirmCancelNetwork(state, confirmCancelNetwork) {
    state.confirmCancelNetwork = confirmCancelNetwork
  },
  deleteIndexNetwork(state, deleteIndexNetwork) {
    state.deleteIndexNetwork = deleteIndexNetwork
  },
  deleteLabelNetwork(state, deleteLabelNetwork) {
    state.deleteLabelNetwork = deleteLabelNetwork
  },
  denyDeleteNetwork(state, denyDeleteNetwork) {
    state.denyDeleteNetwork = denyDeleteNetwork
  },
  formNetwork(state, formNetwork) {
    state.formNetwork = formNetwork
  },
  isModalVisibleNetwork(state, isModalVisibleNetwork) {
    state.isModalVisibleNetwork = isModalVisibleNetwork
  },
  isValidNetworkForm(state, isValidNetworkForm) {
    state.isValidNetworkForm = isValidNetworkForm
  },
  promptDeleteNetwork(state, promptDeleteNetwork) {
    state.promptDeleteNetwork = promptDeleteNetwork
  },
}

export default mutations
